import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import {
  UI_OPERATION_STATUS_ERROR,
  UI_OPERATION_STATUS_SUCCESS,
} from '@uncinc/react-drupal-core';

import Page from '../../containers/Page';
import useOperationStatus from '../../hooks/useOperationStatus';
import useClasses from '../../hooks/useClasses';
import useTypedDispatch from '../../hooks/useTypedDispatch';
import { buddyInviteAccept } from '../../store/actions/Buddy';

import './style.scss';
import { Main } from '../../components';

const PageBuddyInviteAccept = () => {
  const dispatch = useTypedDispatch();
  const status = useOperationStatus('buddy', 'accept');
  const { t } = useTranslation();
  const { buildClass } = useClasses('PageBuddyInviteAccept');
  const { pairingCode } = useParams<{ pairingCode: string }>();

  const translationBase = 'pages.buddy_invite_accept';

  useEffect(() => {
    // Add the pairing code, taken from the url params, and use it to
    // accept the buddy's invitation.
    if (pairingCode) {
      dispatch(buddyInviteAccept(pairingCode));
    }
  }, [pairingCode, dispatch]);

  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    <Page className={buildClass()} title={t(`${translationBase}.title`)}>
      <Main>
        <Container>
          <div className="row">
            <div className="col-md-10 col-lg-8 offset-md-1 offset-lg-2 py-8 py-lg-12">
              {status === UI_OPERATION_STATUS_SUCCESS && (
              <>
                <div className={buildClass('title')}>
                  <h1>{t(`${translationBase}.title`)}</h1>
                </div>

                <div className={buildClass('body')}>
                  {[...t(`${translationBase}.body`, { returnObjects: true })].map((content, idx) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <p key={`buddy_invite_accept_content-${idx}`}>
                      {content}
                    </p>
                  ))}
                </div>
              </>
              )}

              {status === UI_OPERATION_STATUS_ERROR && (
              <div className={buildClass('body')}>
                <p>{t(`${translationBase}.error_message`)}</p>
              </div>
              )}
            </div>
          </div>
        </Container>
      </Main>
    </Page>
  );
};

export default PageBuddyInviteAccept;
